import { disableBodyScroll, enableBodyScroll, clearAllBodyScrollLocks } from './vendors/body-scroll-lock/lib/bodyScrollLock.es6';
import { onDomReady } from './includes/utils';

(function() {

	const mainContent = document.querySelector('.site-main.has-thumbnail .section-content .scrollable');
	if(! mainContent)
		return;
	
	let contentHasScroll = false;
	let scrollTop = 0;
	
	//document.body.ontouchmove = (e) => { console.log('touchemove', e) }; 
	
	const onElementEnter = event => {
		if( contentHasScroll )
			disableBodyScroll();
	}
	const onElementLeave = event => enableBodyScroll();
	
	const onElementScroll = event => {
		if(! contentHasScroll )
			return;
		
		
		if( mainContent.scrollTop < scrollTop ) { // scrolling up
			if( document.body.scrollTop > 0 ) {
				event.preventDefault();
				enableBodyScroll();
			}
		}
		
		if( mainContent.clientHeight + mainContent.scrollTop >= mainContent.scrollHeight )
			clearAllBodyScrollLocks();
			
		scrollTop = mainContent.scrollTop;
	}
	
	const onResize = event => {
		contentHasScroll = mainContent.clientHeight < mainContent.scrollHeight;
	};
	
	mainContent.addEventListener('mouseenter', onElementEnter);
	mainContent.addEventListener('mouseleave', onElementLeave);
	mainContent.addEventListener('scroll', onElementScroll);
	window.addEventListener('resize', onResize);
	
	
	onDomReady(onResize);
})();